import SimplexNoise from "simplex-noise";

class PseudoRandomNumberGenerator {
  simplex;
  scale;
  constructor(seed) {
    this.simplex = new SimplexNoise(seed);
    this.scale = 3.2342323423432;
  }
  getValue(x, y, z = null, w = null) {
    x *= this.scale;
    y *= this.scale;
    if (w == null) {
      if (z == null) {
        return this.simplex.noise2D(x, y);
      }
      z *= this.scale;
      return this.simplex.noise3D(x, y, z);
    }
    w *= this.scale;
    return this.simplex.noise4D(x, y, z, w);
  }
}

export default PseudoRandomNumberGenerator;
